module.exports = __webpack_public_path__ + "media/images/Know-The-Early-Signs-0bb2240b42b3d7ae1e33c5458ef9bfe1.png";